<template>
  <div class="setting-post-time-page">
    <ins-selector v-model="selectPublisherId"></ins-selector>
    <div class="right-container">
      <div class="header-title">Default Post Time</div>
      <div class="main-container">
        <div class="title-tip">
          We will auto apply your default post time when you schedule posts. If
          you have multiple times, they will be applied in order.
        </div>
        <default-setting
          type="post"
          :publisherId="selectPublisherId"
        ></default-setting>
        <!-- <default-setting type="story" v-if="currentPublisher && currentPublisher.socialNetwork === 1" :publisherId="selectPublisherId"></default-setting> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import insSelector from "../../components/common/instagram_selector/Selector";
import defaultSetting from "../../components/setting/default_setting/Index";
import { updateUserInfo } from "../../service/user";
import { showErrorMsg } from "../../utils/errors";
export default {
  name: "SettingDefaultTimePage",
  components: { insSelector, defaultSetting },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    currentPublisher() {
      if (this.user) {
        return this.user.linkedInstagramList.find(
          (l) => l.publisherId === this.selectPublisherId
        );
      } else {
        return { socialNetwork: 1 };
      }
    },
  },
  data() {
    return {
      selectPublisherId: "",
    };
  },
  async created() {
    const loading = this.$loading();
    try {
      await updateUserInfo({});
    } catch (e) {
      showErrorMsg(e);
    } finally {
      loading.close();
    }
  },
};
</script>
<style scoped lang="less">
@import "../../assets/style/theme.less";

.setting-post-time-page {
  display: flex;
  flex: 1;
  .right-container {
    flex: 1;
    height: 100vh;
    .header-title {
      font-size: 18px;
      height: 80px;
      display: flex;
      align-items: center;
      font-weight: 500;
      padding-left: 40px;
      border-bottom: 1px solid @border-color;
    }
    .main-container {
      padding: 20px 40px 40px 40px;
      overflow: auto;
      max-width: 600px;
      height: calc(~"100vh - 80px");
      .title-tip {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
}
</style>
